;(function () {

"use strict";

var MaxLengthView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.maxlen = opts.maxlen || 24;
  },
  update: function (e) {
    var $this = $(e.currentTarget);
    var val = $this.val();
    var $number = $this.parent().find('.max-chars strong');
    var $copy = $this.parent().find('.max-chars span');

    var remaining = this.maxlen - val.length;
    if (remaining < 0) {
      remaining = 0;
    }

    if (remaining === 1) {
      $copy.html('character remaining');
    } else {
      $copy.html('characters remaining');
    }

    $number.html(remaining);

    if (remaining <= 0) {
      $this.val(val.slice(0, this.maxlen));
      return false;
    }
  },
  events: {
    'keyup input': 'update'
  }
})

var ColorSwatchesView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.swatchLimit = opts.swatchLimit || 1;
    $(this.$el).on('click', '.selected-swatch', _.bind(this.removeSwatch, this));
  },
  update: function (e) {
    var $this = $(e.currentTarget);
    var color = $this.data('color');

    var $input = null;
    this.$el.find('.color-swatches-wrapper .hidden-line-item-properties input').each(function () {
      if (!$(this).val()) {
        $input = $(this);
        return false;
      }
    });

    if (!$input) {
      console.log('All values are filled');
      return;
    }

    $input.val(color);
    this.updateSelectedSwatches();
  },
  updateSelectedSwatches: function () {
    var $input = null;

    var $selectedSwatches = this.$el.find('.selected-swatches .swatches');
    $selectedSwatches.empty();

    this.$el.find('.color-swatches-wrapper .hidden-line-item-properties input').each(function () {

      if (!$(this).val()) {        
        return true;
      } else {
        var $selectedSwatch = $('<div class="selected-swatch">'+$(this).val()+'</div>')
        $selectedSwatches.append($selectedSwatch);
      }
    });

    if ($selectedSwatches.children().length === this.swatchLimit) {
      this.$el.find('#AddToCart').removeAttr('disabled', false).removeClass('disabled'); 
    } else {
      this.$el.find('#AddToCart').attr('disabled', 'disabled').addClass('disabled');
    }
  },
  removeSwatch: function (e) {
    var $this = $(e.currentTarget);
    var idx = $this.index();
    var $inputs = this.$el.find('.color-swatches-wrapper .hidden-line-item-properties input');
    var $input = $($inputs[idx]);
    $input.val('');

    var values = [];
    $inputs.each(function(idx) {
      if ($(this).val()) {
        values.push($(this).val());
      }
    });

    $inputs.each(function(idx) {
      $(this).val(values[idx]);
    });

    this.updateSelectedSwatches();

    if (values.length === 0) {
      this.$el.find('.selected-swatches .swatches').append('<div class="none-selected">Select '+this.swatchLimit+' Colors</div>');
    }
  },
  events: {
    'click .color-swatches .swatch': 'update',
  }
})

var ProductFormView = Backbone.View.extend({
  initialize: function () {
    // console.log(' init product form view ');
    this.$addToCartButtons = $.merge(this.$el.find('button[type="submit"]'), $('button.add-to-cart'));

    this.$el.find('.line-item-property').each(function () {
      if ($(this).find('input').attr('maxlength')) {
        new MaxLengthView({ el: this, maxlen: $(this).find('input').attr('maxlength') });
      }
    });

    if (this.$el.find('#product-color-swatches')[0]) {
      new ColorSwatchesView({ el: this.$el, swatchLimit: this.$el.find('#swatch-limit').data('limit') });
      this.$el.find('#AddToCart').attr('disabled', 'disabled').addClass('disabled');
    }
  },
  success: function (d) {
    this.$addToCartButtons.removeClass('loading');
    this.loading = false;
    this.$addToCartButtons.addClass('success');

    _.delay(_.bind(function () { 
      this.$addToCartButtons.removeClass('success'); 
    }, this), 2000);

    window.App.mcv.render(true);

    if ($(window).width() >= 765) {
      $("html, body").animate({ scrollTop: 0 }, 300, 'swing');
    }
  },
  error: function (d) {
    this.$addToCartButtons.removeClass('loading');
    this.loading = false;

    var json = d.responseJSON || {};
    if (json.description) {
      alert(json.description);
    }
  },
  submit: function (e) {
    if (this.loading) {
      console.log('currently loading request. Waiting');
      return false;
    }

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$el.serialize(),
      dataType: 'json',
      success: _.bind(this.success, this),
      error: _.bind(this.error, this)
    };

    this.$addToCartButtons.addClass('loading');
    this.loading = true;
    $.ajax(params);

    return false;
  },
  triggerBabylist: function(e) {
    e.preventDefault();
    e.stopPropagation();

    var $this = $(e.currentTarget);

    var images = $this.data('images') || [];

    images.forEach(function (image, idx) {
      image = image.split('?');
      image.pop();
      images[idx] = image.join('');
    });

    var image = $this.data('image');

    var data = {};
    // data.images = images;
    data.images = image;
    data.title = $this.data('title');
    data.price = $this.data('price');
    data.url = window.location.href;

    bl.addToRegistry(data);
  },
  events: {
    'submit': 'submit',
    'click .babylist-registry-btn': 'triggerBabylist'
  }
});

module.exports = ProductFormView;

}());